import { Box } from "@mui/material";
import React, { FC } from "react";
import Button from "../../../components/Button";
import { useTranslation } from "react-i18next";

interface EditCaseSummaryDrawerFooterProps {
  onSubmit: (isSaveAndMoveNext?: boolean) => void;
  isSubmitDisabled: boolean;
}

const EditCaseSummaryDrawerFooter: FC<EditCaseSummaryDrawerFooterProps> = ({
  onSubmit,
  isSubmitDisabled,
}) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" justifyContent="space-between" gap={2}>
      <Button
        variant="contained"
        onClick={() => {
          onSubmit();
        }}
        disabled={isSubmitDisabled}
        sx={[
          styles.button,
          {
            backgroundColor: "custom.background.brand",
          },
        ]}
      >
        {t("Save_Changes")}
      </Button>
      <Button
        variant="outlined"
        onClick={() => onSubmit(true)}
        disabled={isSubmitDisabled}
        sx={[
          styles.button,
          {
            color: "custom.background.brand",
            borderColor: "custom.background.brand",
          },
        ]}
      >
        {t("Save_and_Next")}
      </Button>
    </Box>
  );
};

const styles = {
  button: {
    flex: 1,
    height: 40,
    borderRadius: 100,
    fontSize: 14,
    fontWeight: 500,
  },
};

export default EditCaseSummaryDrawerFooter;
